import Swiper from 'swiper';

export default function() {
  const tools = document.querySelectorAll('.tools');

  tools.forEach((block) => {
    const itemsWrapper = block.querySelector('.tools__items-wrapper');
    let swiper;

    const observer = new IntersectionObserver((entries, observer) => {
      if (entries[0].isIntersecting) {
        swiper && swiper.autoplay.start();
      } else {
        swiper && swiper.autoplay.stop();
      }
    }, { threshold: 0.1 });

    function swiperInit() {
      if (swiper) return;
      const slider = block.querySelector('.swiper-container');

      swiper = new Swiper(slider, {
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
          waitForTransition: false,
        },
        direction: 'horizontal',
        effect: 'fade',
        slidesPerView: '1',
        speed: 1000,
        loop: true,
        pagination: {
          el: block.querySelector('.swiper-pagination'),
          type: 'bullets',
          clickable: 'true',
        },
        breakpoints: {
          767: {
            pagination: false,
          },
        },
      });
      swiper.autoplay.stop();
      observer.observe(itemsWrapper);
    }

    if (window.innerWidth <= 767) {
      swiperInit();
    }

    window.addEventListener('widthResize', function() {
      if (window.innerWidth > 767) {
        if (!swiper) return;

        observer.disconnect();
        swiper.destroy();
        swiper = null;
      } else {
        swiperInit();
      }
    });
  });
}
